import type { Page } from '../../types';

const coverSheet: Page[] = [
  {
    pageType: 'question',
    title: '1.1 Your details',
    name: 'tenant-details',
    questions: [
      {
        questionType: 'textInput',
        title: 'What is your name',
        name: 'requester-name',
        hint: 'Firstname Lastname',
        userNameFromEmail: true,
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'Your email address',
        name: 'tableau-contact-email',
        userEmail: true,
        rules: {
          required: true,
          email: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'Which department / organisation do you work for',
        name: 'department-or-organisation',
        rules: { required: true },
      },
      {
        questionType: 'textInput',
        title: 'What team do you work for',
        name: 'team-name',
        hint: 'Team name',
        rules: { required: true },
      },
      {
        questionType: 'textarea',
        title: 'Brief description of your team’s purpose',
        name: 'team-purpose',
        hint: 'Briefly describe your team’s main purpose and the work it is responsible for',
        rules: { required: true },
      },
      {
        questionType: 'radio',
        title: 'Were you required to pay for your Tableau licence last financial year?',
        name: 'paid-for-tableau-licence-last-financial-year',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
      {
        questionType: 'radio',
        title: 'Was this team part of the Government People Group (GPG) last year?',
        name: 'team-used-to-be-part-of-gpg',
        options: ['Yes', 'No'],
        rules: { required: true },
        showWhen: [
          {
            field: 'paid-for-tableau-licence-last-financial-year',
            condition: 'equals',
            value: 'No',
          },
        ],
      },
      {
        questionType: 'content',
        title: '',
        name: 'tableau-licence-funding-information',
        description:
          '<p>We will check whether your licence is centrally funded. If it is not, we will contact you to discuss your options. Paid licences cost &pound;1,850 per user per year.</p>',
        showWhen: [
          {
            field: 'paid-for-tableau-licence-last-financial-year',
            condition: 'equals',
            value: 'No',
          },
        ],
      },
      {
        questionType: 'textInputSmall',
        title: 'How many GRID Tableau licences do you require?',
        name: 'number-of-tableau-users',
        rules: {
          required: true,
          number: true,
          min: 1,
          pattern: '^\\d+$',
        },
        errorMessages: {
          pattern: 'Enter a whole number',
        },
      },
      {
        questionType: 'radio',
        title: 'Is this license for you?',
        name: 'single-license-for-requester',
        options: ['Yes', 'No'],
        rules: { required: true },
        showWhen: [
          {
            field: 'number-of-tableau-users',
            condition: 'equals',
            value: '1',
          },
        ],
      },
      {
        questionType: 'dynamicTable',
        title: 'Users requiring a license',
        name: 'tableau-license-users',
        hint: 'Please enter the email addresses of everyone who requires a licence',
        rules: { required: true },
        showWhen: [
          {
            field: 'number-of-tableau-users',
            condition: 'numberGreaterThan',
            value: '1',
          },
          {
            field: 'single-license-for-requester',
            condition: 'equals',
            value: 'No',
          },
        ],
        dynamicTable: {
          showExcelToolbar: false,
          rowHeader: 'User Email Address',
          rowCountField: 'number-of-tableau-users',
          rowKeyPrefix: 'licenseUser',
          strict: true,
          compact: true,
          columns: [
            {
              key: 'emailAddress',
              label: 'Email Address',
              inputType: 'text',
              required: true,
            },
          ],
          rows: [],
        },
      },
    ],
  },
];

export default coverSheet;
